module.exports = __webpack_public_path__ + "static/media/GAOFEN 7.14d3bb9a.czml";